<div class="container">

    <mat-toolbar class="mat-elevation-z2 noselect">

        <span class="logo-central-barra-top">
            <img class="title logo" src="../../../assets/portal_logos.png" alt="logo_unidade">
        </span>

        <button mat-icon-button (click)="menuClick()" style="color: #df1e1e;"
        style="position: relative; z-index: 1000;">
            <div id="hamburgerMenu" class="hamburgerMenu" (click)="toggleNav()">
                <div class="bar1"></div>
                <div class="bar2"></div>
                <div class="bar3"></div>
            </div>
        </button>

        <div>
            <div class="menu" [matMenuTriggerFor]="menu">
                <img src="../../../assets/avatar-sm.png" alt="profile">
                <span></span> <!-- {{ nome ? nome : '' }} -->
            </div>
            <mat-menu #menu="matMenu">
                <div class="profile">
                    <img src="../../../assets/avatar-md.png" alt="profile">
                    <span></span> <!-- {{ user?.funcionario?.nome ? user.funcionario.nome : '' }} -->
                    <span class="setor"></span> <!-- {{ user?.departamento?.nome ? user.departamento.nome : '' }} -->
                </div>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>power_settings_new</mat-icon>
                    <span>Sair</span>
                </button>
            </mat-menu> 
        </div>

    </mat-toolbar>

    <mat-progress-bar *ngIf="showBar" mode="indeterminate" color="primary"></mat-progress-bar>
    
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #menuList [mode]="sidebarMode" opened="true" fixedTopGap="56" id="menuSideNav">
            <mat-nav-list>
                <app-menu-list-item *ngFor="let item of navItemList" [item]="item"></app-menu-list-item>
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content>
            <div class="router">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>